import { useCallback, useEffect, useState } from 'react';
import { AdminNotification, adminNotificationsService } from '../services/firebaseFunctions';

export function useAdminNotifications() {
  const [notifications, setNotifications] = useState<AdminNotification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = adminNotificationsService.subscribe(
      (data) => {
        setNotifications(data);
        setLoading(false);
        setError(null);
      },
      () => {
        setError('Erro ao carregar notificações');
        setLoading(false);
      },
    );
    return unsubscribe;
  }, []);

  const resolveNotification = useCallback(
    async (id: string) => {
      setNotifications(prev => prev.filter(n => n.id !== id));
      try {
        await adminNotificationsService.resolve(id);
      } catch {
        // listener will restore correct state on failure
      }
    },
    []
  );

  return { notifications, loading, error, resolveNotification, reload: () => Promise.resolve() };
}
